"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MethodName = void 0;
var MethodName;
(function (MethodName) {
    MethodName["LOCATIONAUTOCOMPLETE"] = "LOCATIONAUTOCOMPLETE";
    MethodName["VALIDATELOCATION"] = "VALIDATELOCATION";
    MethodName["LOCATIONINPUTCOMPONENTSTRINGPREFILL"] = "LOCATIONINPUTCOMPONENTSTRINGPREFILL";
    MethodName["UNKNOWN"] = "UNKNOWN";
})(MethodName = exports.MethodName || (exports.MethodName = {}));
